<template>
  <div
    :id="'transaction-modal-' + id"
    class="transaction-modal"
    :class="{
      'transaction-modal-failed': transaction.state.isFailed,
      'transaction-modal-pending': 'pending' === transaction.state.state,
      'transaction-modal-credit': ('completed' === transaction.state.state || 'completed_refund' === transaction.state.state || 'completed_funding' === transaction.state.state) && 'credit' === transaction.side
    }"
    :onClick="closeTransactionModal"
  >
    <div class="transaction-modal-content">
      <div class="modal-transaction-resizer">
        <svg xmlns="http://www.w3.org/2000/svg" width="78" height="3" viewBox="0 0 78 3" fill="none">
          <path d="M1.5 1.5H76.5" stroke="#0B1C48" stroke-opacity="0.1" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="transaction-modal-part-1">
        <div v-if="transaction.merchant.name.length < 20 " class="transaction-modal-merchant">
          {{ transaction.merchant.name }}
        </div>
        <div  v-else class="transaction-modal-merchant tooltip">
          {{ transaction.merchant.name.substr(0, 18) }}...
          <span class="tooltiptext">{{ transaction.merchant.name }}</span>
        </div>
        <TransactionType :type="transaction.type" />
      </div>
      <div class="transaction-modal-part-2">
        <div class="transaction-modal-detail-line">
          <div class="transaction-modal-detail-title">
            Le
          </div>
          <div class="transaction-modal-detail-text">
            {{ transaction.date }} à {{ transaction.time }}
          </div>
        </div>
        <div class="transaction-modal-detail-line">
          <div class="transaction-modal-detail-title">
            Avec
          </div>
          <div class="transaction-modal-detail-text">
            {{ transaction.campaign.name }}
          </div>
        </div>
        <div v-if="transaction.state.isFailed" class="transaction-modal-detail-line">
          <div class="transaction-modal-detail-title">
            Motif
          </div>
          <div class="transaction-modal-detail-text">
            {{ $t("transaction.errorMessage." + transaction.state.state) }}
          </div>
        </div>
      </div>
      <div class="transaction-modal-part-3">
        <div class="transaction-modal-amount">
          <span v-if="0 < transaction.amount">+</span>{{ (transaction.amount/100).toLocaleString('fr-FR', { minimumFractionDigits: 2 }) }}€
        </div>
      </div>
      <div class="transaction-modal-padding"></div>
    </div>
  </div>
</template>

<script setup>
  import TransactionType from "@/components/Transaction/TransactionType.vue";

  const props = defineProps({
    'id': {
      type: String
    },
    'transaction': {
      type: Object,
      default: () => ({
        merchant: null,
        campaign: null,
        socialEvent: null,
        date: null,
        time: null,
        timestamp: null,
        amount: null,
        side: null,
        expired: null,
        state: null,
        type: null
      })
    }
  })

  const closeTransactionModal = (e) => {
    if (e.target.classList.contains('transaction-modal')) {
      setTimeout(() => {
        e.target.style.display = "none";
        document.body.style.overflowY = 'scroll';
      }, "0");
    }
  };
</script>

<style scoped lang="scss">
  .transaction-separator {
    width: 100%;
    stroke-width: 1px;
    stroke: var(--ce-color-blue-ce-marque-blanche-50, rgba(39, 92, 241, 0.04));
    display: flex;
    justify-content: center;
  }

  .transaction-modal {
    z-index: 2;
    width: 100%;
    height: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    background: var(--ce-color-dark-blue-ce-marque-blanche-100, rgba(11, 28, 72, 0.06));
    display: none;

    .transaction-modal-content {
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;

      display: flex;
      /*padding: var(--spacing-82-rem-32-px, 32px);*/
      padding-left: 32px;
      padding-right: 32px;
      /*padding-bottom: 32px;*/
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 0;

      border-radius: var(--spacing-5125-rem-20-px, 20px) var(--spacing-5125-rem-20-px, 20px) var(--spacing-00-px-0-px, 0px) var(--spacing-00-px-0-px, 0px);
      border: 1px solid var(--ce-color-blue-ce-marque-blanche-200, rgba(39, 92, 241, 0.10));
      background: #FFF;

      .modal-transaction-resizer {
        padding-top: 16px;
        padding-bottom: 32px;
      }

      .transaction-modal-part-1 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: var(--ce-color-dark-blue-ce-marque-blanche-500, #0B1C48);

        .transaction-modal-merchant {
          text-align: center;
          font-size: 16px;
          font-weight: 700;
          line-height: 24px;
        }
      }

      .transaction-modal-part-2 {
        display: flex;
        padding-top: 24px;
        padding-left: 48px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 16px;

        .transaction-modal-detail-line {
          display: flex;
          align-items: center;
          gap: 24px;
          align-self: stretch;

          .transaction-modal-detail-title {
            width: 35px;
            color: var(--ce-color-dark-blue-ce-marque-blanche-400, rgba(11, 28, 72, 0.50));
            font-size: 14px;
            font-weight: 500;
            line-height: 24px;
          }

          .transaction-modal-detail-text {
            color: var(--ce-color-dark-blue-ce-marque-blanche-500, #0B1C48);
            font-size: 14px;
            font-weight: 700;
            line-height: 24px;
            text-align: left;
          }
        }
      }

      .transaction-modal-part-3 {
        padding-top: 24px;
        color: var(--ce-color-dark-blue-ce-marque-blanche-500, #0B1C48);

        .transaction-modal-amount {
          font-size: 20px;
          font-weight: 700;
          line-height: 24px;
        }
      }

      .transaction-modal-padding {
        height: 40px;
      }
    }
  }

  .transaction-modal-credit {
    .transaction-modal-content {
      .transaction-modal-part-1 {
        color: var(--CE-Brand-Primaire-500, #275CF1);
      }
    }

    .transaction-modal-content {
      .transaction-modal-part-3 {
        color: var(--CE-Brand-Primaire-500, #275CF1);
      }
    }
  }

  .transaction-modal-pending {
    .transaction-modal-content {
      .transaction-modal-part-1 {
        color: var(--ce-color-dark-blue-ce-marque-blanche-500, #0B1C48);
      }
    }

    .transaction-modal-content {
      .transaction-modal-part-3 {
        color: var(--ce-color-dark-blue-ce-marque-blanche-500, #0B1C48);
      }
    }
  }

  .transaction-modal-failed {
    .transaction-modal-content {
      .transaction-modal-part-1 {
        color: var(--CE-Brand-Danger-Danger-light, #F03D3D);
      }
    }

    .transaction-modal-content {
      .transaction-modal-part-3 {
        color: var(--CE-Brand-Danger-Danger-light, #F03D3D);
      }
    }
  }

</style>
